<template>
  <v-card class="signee-group-card" variant="outlined">
    <div v-show="showDragNotch" class="signee-group-selector">
      <v-icon class="group-grip-icon" :class="{ dragging }" size="medium">
        fas fa-grip-dots-vertical
      </v-icon>
    </div>
    <slot name="content"></slot>
    <slot name="footer"></slot>
  </v-card>
</template>

<script setup lang="ts">
defineProps({
  showDragNotch: { type: Boolean, default: false },
  dragging: { type: Boolean, default: false }
});
</script>
<style scoped lang="scss">
@use 'sass:map';
@use '@/styles/settings.scss' as *;

.signee-group-card {
  transition-property: all;
  margin-left: 0;
  overflow: visible;
  border-radius: 5px;
  background-color: rgb(var(--v-theme-grey-lighten-5)) !important;
  border-color: rgba(0, 0, 0, 0.12) !important;

  &.drag {
    margin-top: 8px;
    margin-bottom: 8px !important;
  }

  &:has(+ .drag) {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }

  // custom breakpoint, does not match vuetify breakpoints
  @media (min-width: 1024px) {
    min-width: 385px;
  }
}

.signee-group-selector {
  position: absolute;
  padding-top: 2px;
  padding-bottom: 2px;
  border: 1px solid rgb(var(--v-theme-grey-lighten-5));
  border-radius: 5px 0 0 5px !important;
  border-right: 1px solid rgb(var(--v-theme-grey-lighten-5));
  max-width: 22px;
  color: rgb(var(--v-theme-grey-darken-1));
  top: calc(50% - 21px);
  background-color: rgb(var(--v-theme-grey-lighten-5));
  left: -21px !important;
  display: flex;
  justify-items: center;
  align-items: center;
}

.group-grip-icon {
  margin-top: 4px;
  margin-bottom: 4px;
  border-radius: 4px;

  &:hover {
    background-color: rgb(var(--v-theme-primary));
    color: white !important;
    cursor: grab;
  }

  &.active {
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: grabbing;
  }

  &.dragging {
    background-color: unset !important;
    color: unset !important;
  }
}
</style>
